import $ from 'jquery';
import config from '../config';
const URL_API = config.urlApi+'controllers/getLastWeekVisitors.controller.php';

export default function getWeekVisits(values){
    return $.ajax({
        data: values,
        url: URL_API,
        type: 'GET'
    })
}